import React, { Component } from 'react';
import { withRouter } from 'next/router';
import { ThemeProvider } from 'styled-components';
import { connect } from 'react-redux';

import withi18n from '../utils/withI18n';
import lightTheme from '../themes/light';
import { getLabel } from '../utils/i18n';
import Regrex from '../utils/regrex';
import Layout from '../layout';
import H5Layout from '../h5/layout';
import ErrorPage from './_error';
import GetBaseInitialProps from '../network/GetBaseInitialProps';
import { getBlogDetail } from '../actions/actionsSet/blog';
import BlogHeader from '../components/Blog/SubHeader';
import BlogHeaderH5 from '../h5/components/Header/blog-header';
import BlogDetail from '../components/Blog/detail';
import BlogDetailH5 from '../h5/components/Blog/detail';
import { getBlogLocales } from '../utils/locales';

const formatLink = title => title.replace(Regrex.punctuation, '').replace(/ /g, '-');

type Props = {
  locale: string,
  metaData: {
    title: string,
    keywords: string,
    description: string,
  },
  router: Object,
  i18n: Object,
  blogDetail: Object,
  isMobile: boolean,
  blogError: boolean,
  hostName: string
};

const mapStateToProps = ({ blogDetail, blogError }) => ({ blogDetail, blogError });
const mapDispatchToProps = null;

export default
@withRouter
@withi18n('blog')
@connect(
  mapStateToProps,
  mapDispatchToProps
)
class BlogDetailPage extends Component<Props> {
  static defaultProps = {
    locale: 'en',
    metaData: {},
    i18n: {},
  };

  static getInitialProps = async params => {
    const {
      isServer,
      req,
      res,
      query: {
        pid, locale, name,
      },
    } = params;
    const { title } = await getBlogDetail(pid, locale, req)(params.store.dispatch);
    if (!title && locale !== 'en') {
      const url = `/en/blog/${pid}/${name}`;
      isServer ? res.redirect(url) : window.location.replace(url);
      return {};
    }
    if (title && decodeURI(name) !== formatLink(title)) {
      const url = `/${locale}/blog/${pid}/${encodeURI(formatLink(title))}`;
      // permanent redirections is better here
      isServer ? res.redirect(url) : window.location.replace(url);
      return {};
    }
    return GetBaseInitialProps(params, { withProductsData: false, realRedirect: false, module: 'blog' });
  };

  componentDidMount() {
    if (window) {
      window.scrollTo(0, 0);
    }
  }

  getOgImgUrl(banner) {
    let ogImg = '';
    if (banner) {
      try {
        const bannerObj = JSON.parse(banner);
        ogImg = bannerObj.bannerUrl;
      } catch (e) {
        // do nothing
      }
    }
    return ogImg;
  }

  renderH5Content(ogImage) {
    const {
      locale, metaData, blogDetail: info, i18n, hostName,
    } = this.props;

    return (
      <H5Layout
        locale={locale}
        emitAmp={true}
        hostName={hostName}
        omitHeader={true}
        omitVerifyToken={true}
        metaData={{
          ...metaData,
          title: `${info.title} | ${getLabel('exchange-blog-header-binanceBlogTitle', i18n)}`,
          description: info.brief || getLabel('exchange-blog-header-BlogTitleTow', i18n),
          ogImage,
        }}
        content={(
          <React.Fragment>
            <BlogHeaderH5 locales={info.locales} />
            <BlogDetailH5 locale={locale} info={info} />
          </React.Fragment>
          )}
      />
    );
  }

  render() {
    const {
      locale,
      metaData,
      blogDetail: info,
      i18n,
      isMobile,
      blogError,
      hostName,
    } = this.props;
    if (blogError) {
      return <ErrorPage i18n={i18n} locale={locale} statusCode={404} />;
    }
    const ogImage = this.getOgImgUrl(info.banner);
    const locales = getBlogLocales(info.locales || []);
    return (
      isMobile ? this.renderH5Content(ogImage)
        : (
          <ThemeProvider theme={lightTheme}>
            <Layout
              locales={locales}
              locale={locale}
              emitAmp={true}
              hostName={hostName}
              metaData={{
                ...metaData,
                title: `${info.title} | ${getLabel('exchange-blog-header-binanceBlogTitle', i18n)}`,
                description: info.brief || getLabel('exchange-blog-header-BlogTitleTow', i18n),
                ogImage,
              }}
              omitFooterTotalUpdate={true}
              omitHeaderLangSelect={true}
              content={(
                <React.Fragment>
                  <BlogHeader />
                  <BlogDetail locale={locale} info={info} />
                </React.Fragment>
        )}
            />
          </ThemeProvider>
        ));
  }
}
